const Ru = {
  translation: {
    component: {
      selectDate: "Выберите дату",
      export: "Экспорт",
      to: "по",
      selectCamera: "Выберите камеру",
    },
    month: {
      январь: "январь",
      февраль: "февраль",
      март: "март",
      апрель: "апрель",
      май: "май",
      июнь: "июнь",
      июль: "июль",
      август: "август",
      сентябрь: "сентябрь",
      октябрь: "октябрь",
      ноябрь: "ноябрь",
      декабрь: "декабрь",
    },
    caseNames: {
      response: "Отклик",
      gratitude: "Благодарность",
      offer: "Предложение",
      other: "Иное",
      comprehensivePlanSER: "Комплексный план",
      crimeScene: "Место совершения преступления",
      hydrologicalMonitoring: "Гидрологический мониторинг",
      meteorologicalMonitoring: "Метеорологический мониторинг",
      weatherForecast: "Прогноз погоды",
      forPeriod: "За период",
      incident: "Жалоба",
      inquiry: "Заявление",
      informationRequest: "Запрос",
      sinceLaunch: "С момента запуска",
      table: "Таблица",
      resetParameters: "Сбросить параметры",
      predict: "Спрогнозировать",
      change_of_deviation: "Изменение отклонения",
      used_for_calculating_error_value:
        "Используется для вычисления значения погрешности.",
      changes_in_girls_birth_rate:
        "Изменения рождаемости девочек в последующих годах.",
      girls_birth_rate_coefficient:
        "Коэффициент рождаемости девочек, число родившихся девочек на 1000 женщин.",
      changes_in_boys_birth_rate:
        "Изменения рождаемости мальчиков в последующих годах.",
      boys_birth_rate_coefficient:
        "Коэффициент рождаемости мальчиков, число родившихся мальчиков на 1000 женщин.",
      migration_balance_change_years:
        "Изменение сальдо миграции в последующих годах.",
      population_difference:
        "Разница между количеством лиц, прибывших и количеством лиц, выбывших. Пропорциональное влияние на численность населения в зависимости от значения.",
      changes_male_mortality_rate:
        "Изменения коэффициента смертности мужчин в последующих годах",
      female_mortality_rate:
        "Коэффициент смертности женщин, число умерших на 1000 человек",
      changes_in_male_mortality_rate:
        "Изменения коэффициента смертности мужчин в последующих годах",
      male_mortality_rate:
        "Коэффициент смертности мужчин, число умерших на 1000 человек",
      male_mortality_change: "Изменение смертности мужчин",
      female_mortality_per_1000: "Смертность женщин на 1000 человек",
      female_mortality_change: "Изменение смертности женщин",
      migration_balance: "Сальдо миграции",
      migration_balance_change: "Изменение сальдо миграции",
      birth_rate_boys: "Рождаемость (мальчики)",
      birth_rate_boys_change: "Изменение рождаемости (мальчики)",
      birth_rate_girls: "Рождаемость (девочки)",
      birth_rate_girls_change: "Изменение рождаемости (девочки)",
      newborn_mortality_boys: "Смертность новорожденных (мальчики)",
      newborn_mortality_girls: "Смертность новорожденных (девочки)",
      male_mortality_per_1000: "Смертность мужчин на 1000 человек",
      forecasting: "Прогнозирование",
      populationForecasting: "Прогнозирование численности населения",
      "Умышленное причинение легкого вреда здоровью":
        "Умышленное причинение легкого вреда здоровью",
      Хулиганство: "Хулиганство",
      Мошенничество: "Мошенничество",
      "Незаконное культивирование запрещенных к возделыванию растений":
        "Незаконное культивирование запрещенных к возделыванию растений",
      Кража: "Кража",
      "Доведение до самоубийства": "Доведение до самоубийства",
      "Умышленное причинение средней тяжести вреда здоровью":
        "Умышленное причинение средней тяжести вреда здоровью",
      "Незаконное обращение с наркотическими средствами":
        "Незаконное обращение с наркотическими средствами",
      Грабеж: "Грабеж",
      school: "Школа",
      dtp: "ДТП",
      publicSafety: "Общественная безопасность",
      forecast: "Прогнозирование",
      population: "Численность населения",
      criminalSituation: "Криминогенная обстановка",
      economy: "Экономика",
      businessCard: "Карта бизнеса",
      roadTrafficAccidents: "Дорожно-транспортные происшествия",
      income: "Доходы с накоплением",
      costs: "Расходы с накоплением",
      expensesWithoutSavings: "Расходы",
      IncomeWithoutAccumulation: "Доходы",
      healthCare: "Здравоохранение",
      morbidityData: "Данные заболеваемости (DamuMed)",
      infrastructure: "Инфраструктура",
      repairAndConstruction:
        "План ремонта и строительства инфраструктурных сетей",
      education: "Образование",
      social: "Обращения граждан",
      newAppeals: "Работа Open City",
      appealsMonitoring: "Мониторинг исполнения",
      categoryAnalytics: "Аналитика категорий",
      monitoringState: "Мониторинг государственных закупок",
      buisnesMap: "Карта бизнеса",
      ecology: "Экология",
      airPollution: "Загрязнение воздуха",
      analyticalIndicators: "Аналитические индикаторы",
      videoStreams: "Видеопотоки",
      videoStream: "Видеопоток",
      pedestrianFlow: "Пешеходный поток",
      carFlow: "Автомобильный поток",
      distributionOfChildrenInKindergartens:
        "Распределение детей по детским садам",
      distributionOfPupilsBySchool: "Распределение учеников по школам",
      homePage: "Главная страница",
      error: "Ошибка доступа",
      infobus: "Общественный транспорт",
      monitoringSmi: "Мониторинг СМИ",
      transport: "Транспорт",
      routeSchedule: "Расписание маршрутов",
      schoolsMenu: "Школы",
      budgetIncomeOutcome: "Доходы и расходы",
    },
    error: {
      doNotHaveAccessToViewThisModule:
        "У вас нет доступа к просмотру данного модуля",
    },
    loginPage: {
      information: "СИТУАЦИОННЫЙ ЦЕНТР ЖЫЛЫОЙСКОГО РАЙОНА",
    },
    mainPage: {
      productionVolume: "Объем продукции (товаров, услуг)",
      productionVolumeBillion: "Объем продукции (товаров, услуг) в млрд тенге",
      physicalVolumeIndexByMonths: "Индекс физического объема по месяцам (%)",
      homePage: "Главная страница",
      city: "г. Кульсары",
      notDefined: "Не определён",
      robbery: "Грабеж",
      information: "СИТУАЦИОННЫЙ ЦЕНТР ЖЫЛЫОЙСКОГО РАЙОНА",
      profile: "Ваш профиль",
      exit: "Выход",
      instruction: "Инструкция",
      main: "Главная",
      statisticalPanel: "Статистическая панель",
      trafficAccidentsByDistrict: "ДТП по районам",
      crimeCategory: "Категория преступления",
      schoolPopulationStructure: "Структура наполненности школ",
      numberOfVisitsToTheEmergencyRoom: "Количество обращений в приемный покой",
      fullnessStructure: "Структура наполненности",
      numberOfSchools: "Количество школ",
      total: "Общее количество",
      projectCapacity: "Проектная мощность",
      surplus: "Профицит",
      norm: "Норма",
      deficit: "Дефицит",
      export: "Экспорт",
    },
    sideMenu: {
      menu: "Меню",
      publicSafety: "Общественная безопасность",
      dtp: "ДТП (Дорожно-транспортные происшествия)",
      criminalSituatuin: "Криминогенная обстановка",
      economy: "Экономика",
      businessCard: "Карта бизнеса",
      income: "Доходы",
      costs: "Расходы",
      healthCare: "Здравоохранение",
      damumed: "Данные заболеваемости (DamuMed)",
      infastructure: "Инфраструктура",
      repairAndConstruction:
        "План ремонта и строительства инфраструктурных сетей",
      education: "Образование",
      social: "Обращения граждан",
      airPollution: "Загрязнение воздуха",
      analyticalIndicators: "Аналитические индикаторы",
      videoStreams: "Видеопотоки",
      videoStream: "Видеопоток",
      pedestrianFlow: "Пешеходный поток",
      carFlow: "Автомобильный поток",
      newAppeals: "Работа Open City",
      appealsMonitoring: "Мониторинг обращений",
      monitoringState: "Мониторинг государственных закупок",
      categoryAnalytics: "Аналитика категорий",
      ecology: "Экология",
      distributionOfChildrenInKindergartens:
        "Распределение детей по детским садам",
      distributionOfPupilsBySchool: "Распределение учеников по школам",
      schoolsMenu: "Школы",
    },
    publicSafety: {
      dtp: {
        homePage: "Главная страница",
        involvingPublicTransport: "С участием общественного транспорта",
        withTheParticipationOfPedestrian: "С участием пешехода",
        intoxicated: "С алкогольным опьянением",
        accidentCard: "Карточка ДТП",
        violation: "Нарушение",
        town: "Город",
        date: "Дата",
        lighting: "Освещение",
        driverCondition: "Состояние водителя",
        culprit: "Виновник",
        timesOfDay: "Время суток",
        violationCategory: "Категория нарушения",
        areas: "Место ДТП",
        comparitiveAnalysisOfRoadAccidentsByMonth:
          "Сравнительный анализ ДТП по последним месяцам",
        numberOfAccidents: "Количество ДТП за ",
        weather: "Погодные условия",
        dusk: "Сумерки",
        day: "День",
        night: "Ночь",
        total: "Общее количество",
      },
      crime: {
        area: "Район",
        category: "Категория",
        numberOfCrimes: "Количество преступлений",
        crimeCard: "Карточка преступления",
        severity: "Тяжесть",
        article: "Статья",
        dateOfUD: "Дата совершения УД (уголовное дело)",
        dateOfInitiationOfUD: "Дата возбуждения УД (уголовное дело)",
        KUI: "№ КУИ (книга учета информации)",
        authority: "Орган (Отдел полиции, Управление полиции)",
        street: "Улица",
        house: "Дом",
        regions: "Регионы",
        region: "Регион",
        registrationAuthority: "Орган регистрации",
        crimeCategory: "Категория преступления",
      },
    },
    economy: {
      businessCard: {
        status: "Статус",
        dateOfUpdate: "Дата актуализации",
        startDate: "Начальная дата",
        finalDate: "Конечная дата",
        registrationDate: "Дата регистрации",
        BIN: "БИН (бизнес-идентификационный номер)",
        activity: "Активность",
        typeOfLegalUnit: "Тип правовой единицы",
        area: "Район",
        OKED: "ОКЭД (общий классификатор экономической деятельности)",
        taxDebtors: "Налоговые должники",
        taxCodeViolators: "Нарушители налогового кодекса",
        inactiveEnterprises: "Неактивные предприятия",
        incorrectlyRegistered: "Неверно зарегистрированные",
        wrongAddress: "Неверный адрес",
        bankrupts: "Банкроты",
        pseudoEnterprise: "Псевдо предприятия",
        totalEnterprises: "Всего предприятий",
        typeOfLegalUnits: "Тип правовых единиц",
        totalDistricts: "Всего районов",
        totalOKED: "Всего ОКЭД",
        totalRegisteredOrganizations: "Всего зарегистрированных организаций",
        totalOperatingOrganizations: "Всего действующих организации",
        numberOfOrganizationsByType: "Количество организации по типу",
        numberOfOKEDByTypeOfOrganization: "Количество ОКЭД по типу организации",
        numberOfOrganizationsByDistrict: "Количество организации по районам",
        numberOfOrganizationsByOKED: "Количество организации по ОКЭД",
        numberOfOrganizationsByDimension:
          "Количество организации по размерности",
      },

      income: {
        period: "Период",
        paymentPlanForTheYear: "План по платежам на год",
        yearlyPlanExecution: "Исполнение плана на год",
        annualIncomePlan: "План поступлений на год",
        executionOfThePlanForThePeriod: "Исполнение плана на период",
        budgetExecutionSchedule: "График исполнения бюджета",
        executionPlan: "План исполнений",
        execution: "Исполнение",
        categoryName: "Наименование категории",
        nonPerformance: "Неисполнение",
      },
      costs: {
        paymentPlanForTheYear: "План по платежам на период",
        ABP: "АБП (Администратор бюджетных программ)",
      },
    },
    healthCare: {
      damuMed: {
        numberOfAccidents: "Количество ДТП",
        numberOfSchools: "Количество Школьные",
        numberOfIndustrialFacilities: "Количество Промышленные",
        numberOfQueues: "Количество очередей",
        numberOfInjuries: "Количество травм",
        numberOfThermalInjuries: "Количество термических поражений",
        numberOfPoisonings: "Количество отравлений",
        numberFromYesterday: "Количество вчера",
        numberFromToday: "Количество сегодня",
        numberOfRequests: "Количество обращений",
        numberOfPeopleWithARVI: "Количество обратившихся с ОРВИ",
        numberOfTraumaVisits: "Количество обращений с травмами",
        numberOfVisitsToTheEmergencyRoom:
          "Количество обращений в приемный покой",
        total: "Общее количество",
        numberOfCasesWithARVI: "Количество обращений с ОРВИ",
        numberOfQueuesInClinics: "Количество очередей в поликлиниках",
        numberOfFatalitiesFromInjuries: "Количество летальности от травматизма",
      },
    },
    infrastructure: {
      repairAndConstruction: {
        responsible: "Ответственный",
        category: "Категория",
        contractor: "Подрядчик",
        selectDate: "Выберите дату",
        showIntersections: "Показать пересечения",
        redPlannedRenovation: "Красным - запланированный ремонт",
        yellowInProgress: "Желтым - в работе",
        greenDone: "Зеленым - выполнено",
        categoryOfWork: "Категория работ",
        street: "Улица",
        plot: "Участок",
        contractorContacts: "Контакты подрядчика",
        warrantyPeriod: "Гарантийный период",
        start: "Начало",
        ending: "Окончание",
        openingOfTheRoadway: "Вскрытие дорожного полотна",
        overlappingTheStreet: "Перекрытие улицы",
        comments: "Комментарии",
        cost: "Стоимость ",
        amountFor2021: "Сумма на 2021",
        length: "Протяженность",
        whoAcceptedTheWork: "Кто принял работы",
      },
    },
    education: {
      childrenKindergartens: {
        elements: "Элементы",
        averageIndicatorsForPeriod: "Средние показатели на период с",
        openFilter: "Открыть фильтр",
        numberOfPreschoolOrganizations: "Количество дошкольных организаций",
        actualFullness: "Фактическая наполненность",
        deviation: "Дефицит мест",
        queue: "В очереди",
        issuedDirections: "Свободных мест",
        enrolled: "Профицит мест",
        fullnessOfDDO: "Наполненность ДДО (детских дошкольных организации)",
        DDOType: "Вид ДДО",
        preschoolMiniCenter: "Дошкольный мини-центр",
        kindergarten: "Детский сад",
        nurseryGarden: "Ясли-сад",
        sanatoriumNurseryGarden: "Санаторный ясли-сад",
        languageOfInstruction: "Язык обучения",
        mixed: "Смешанный",
        kazakh: "Казахский",
        russian: "Русский",
        durationOfStay: "Продолжительность нахождения",
        fullDayOfStay: "С полным днем пребывания",
        partTime: "С неполным днем пребывания",
        withTwentyFourStay: "С круглосуточным пребыванием",
        queueStatus: "Статус очереди",
        fullnessStructure: "Структура наполненности",
        surplus: "Профицит",
        norm: "Норма",
        deficit: "Дефицит",
        freePlaces: "Свободные места",
        pivotTable: "Сводная таблица",
        name: "Наименование",
        address: "Адрес",
        formOfInstitutions: "Форма учреждений ",
        fullness: "Заполненность",
        area: "Район",
        projectCapacity: "Проектная мощность",
        district: "Район",
        formOfInstitution: "Форма учреждения",
        designCapacity: "Проектная мощность",
        DDOtype: "Вид ДДО",
      },
      pupilsBySchool: {
        generalShortageOfPlaces: "Общий дефицит мест",
        totalArea: "Общая площадь",
        fullness: "Наполненность",
        schoolType: "Тип школ",
        secondarySchools: "Общеобразовательные школы",
        specializedSchoolsForGiftedChildren:
          "Специализированные школы для одаренных детей",
        lyceum: "Лицей",
        gymnasiums: "Гимназии",
        structureOfSchoolsByShifts: "Структура школ по сменам",
        firstShift: "Первая смена",
        secondShift: "Вторая смена",
        studentsByShifts: "Учащиеся по сменам",
        schoolsWithOneShift: "Школы с одной сменой",
        schoolsWithTwoShifts: "Школы с двумя сменами",
        terrain: "Местность",
        locality: "Населенный пункт",
        view: "Вид",
        typeOfOwnership: "Форма собственности ",
        yearBuilt: "Год постройки",
        magnitudeOfTheDeficit: "Величина дефицита",
        numberOfSchools: "Количество школ",
        projectCapacity: "Проектная мощность",
        schoolPopulationStructure: "Структура наполненности школ",
        surplus: "Профицит",
        norm: "Норма",
        deficit: "Дефицит",
        openFilter: "Открыть фильтр",
        pivotTable: "Сводная таблица",
        name: "Наименование",
        area: "Район",
        address: "Адрес",
        languageOfInstruction: "Язык обучения",
        projectCapacityAll: "Проектная мощность*",
        actualFullness: "Фактическая наполненность",
      },
      infobus: {},
      monitoringSmi: {},
    },
    videoStreamPage: {
      menu: "Меню",
      org: "Ситуационный центр Жылыойского района",
      city: "г. Кульсары",
      role: "Администратор",
      prof: "Ваш профиль",
      logout: "Выход",
      home: "Главная страница",
      crumb: "Видеопоток",
      title: "Видеопоток",
      term: "Срок работ",
      tPlan: "Плановый",
      tFact: "Фактический",
      from: "От",
      to: "До",
      fSrc: "Источник",
      fAddr: "Адрес",
      fLoc: "Местоположение",
      all: "Все",
      reset: "Сбросить фильтры",
      secView: "Просмотр видеопотока",
      secStat: "Статистическая панель",
      secPies: "Сводная информация по видеопотокам",
      secTable: "Сводная таблица видеопотоков",
      pick: "Видеопоток",
      fullscreen: "Полный экран",
      kTotal: "Всего видеопотоков",
      kSrc: "Наименований источников",
      kLoc: "Местоположений",
      kFile: "С видеофайлом",
      cSrc: "Видеопотоки по наименованию источника",
      cAddr: "Видеопотоки по адресу",
      cLoc: "Видеопотоки по местоположению",
      colSrc: "Наименование источника",
      colAddr: "Адрес видеопотока",
      colLoc: "Местоположение",
      colFile: "Видеофайл",
      colPlan: "Плановый срок",
      download: "Скачать файл",
      colFact: "Фактический срок",
      searchPh: "Поиск по всем атрибутам",
      records: "записей",
      unitsShort: "ед.",
      found: "Найдено",
      foundUnit: "видеопотоков",
      noVideoShort: "Видеозапись недоступна",
      noSelection: "Записи не выбраны",
      fileYes: "прикреплён",
      fileNo: "не прикреплён",
      noVideoT: "Видеозапись недоступна",
      noVideoD:
        "К выбранному видеопотоку не прикреплён видеофайл либо файл недоступен. Выберите другой видеопоток.",
      emptyT: "Записи видеопотоков отсутствуют",
      emptyD:
        "По установленным значениям фильтров записи не найдены. Измените параметры фильтрации или сбросьте фильтры.",
      searchEmptyD:
        "По строке поиска ничего не найдено. Измените или очистите строку поиска.",
      lgPie:
        "Цвет сектора обозначает значение разреза, а не статус — статусы в модуле не рассчитываются",
      lgDash:
        "«—» означает, что срок работ не указан; такие записи не отображаются нулём",
      lgTerm:
        "При выборе диапазона дат записи без указанного срока подключения не отображаются",
      lgClick:
        "Нажатие на сектор диаграммы или строку её легенды отбирает записи по этому значению; повторное нажатие снимает отбор",
      onFilter: "фильтр",
      noFilter: "все записи",
      period: "срок",
      loadErrT: "Не удалось загрузить данные",
      loadErrD: "Проверьте соединение и повторите запрос.",
      retry: "Повторить",
      loading: "Загрузка…",
    },
    schools: {
      title: "Школы",
      crumbHome: "Главная страница",
      crumbSchools: "Школы",

      // фильтры
      filterShift: "Сменность",
      filterLang: "Язык обучения",
      filterStatus: "Загруженность",
      allOption: "Все",
      reset: "Сбросить фильтры",
      filterCaption: "фильтр",
      filterNone: "без фильтров",

      // секции
      sectionSummary: "Статистическая панель",
      sectionCuts: "Распределение школ по разрезам",
      sectionChart: "Проектная мощность и число учеников по школам",
      sectionTable: "Сводная таблица школ",

      // заголовки круговых
      cutShift: "По сменности",
      cutLang: "По языку обучения",
      cutStatus: "По загруженности",

      // KPI
      kTotal: "Школ в выборке",
      kGood: "В пределах мощности",
      kBad: "Превышение мощности",
      kStudents: "Учеников",
      kCap: "Проектная мощность, мест",
      kDeficit: "Дефицит мест",

      // столбчатая диаграмма
      chCap: "Проектная мощность",
      chStudents: "Число учеников",

      // колонки таблицы
      colSchool: "Школа",
      colCap: "Мощность",
      colStudents: "Учеников",
      colLoad: "Загруженность",
      colDeficit: "Дефицит мест",
      colTeachers: "Учителей",
      colShift: "Сменность",
      colLang: "Язык обучения",
      colStatus: "Статус",
      loadHint:
        "Превышение мощности при двухсменном обучении — штатная ситуация: во вторую смену используются те же места. Загруженность — отношение контингента к проектной мощности здания, а не оценка работы школы.",

      // легенда
      lgGood: "В пределах мощности (до 100%)",
      lgBad: "Превышение мощности (свыше 100%)",
      lgNote:
        "Загруженность = ученики / мощность · Дефицит = ученики минус мощность, не меньше 0",
      lgCat:
        "Цвет на диаграммах «Сменность» и «Язык обучения» — категория, а не оценка",

      // экспорт
      export: "Экспорт",
      expXlsx: "Excel",
      expPdf: "PDF",
      expHint: "Выгрузить сводную таблицу с учётом текущих фильтров",
      expEmpty: "Нет строк для выгрузки",
      exportError: "Не удалось сформировать файл, повторите попытку",

      // состояния
      noRows: "По выбранным фильтрам записей нет",
      loadError: "Не удалось загрузить данные",
      retry: "Повторить",

      // единицы
      pcs: "шк.",
    },
    budget: {
      // Заголовок страницы для конфига крошек/роутинга лэйаута (сама шапка и крошки
      // рисуются лэйаутом; ключи шапки — center/menu/city/… — здесь не нужны).
      title: "Доходы и расходы",
      legQ: "% к бюджету считается от скорректированного бюджета",

      sumIncome: "Доходы",
      sumExpense: "Затраты",
      plan: "План",
      fact: "Факт",
      share: "Доля",
      execToPlan: "Исполнение к плану",
      execToBud: "Исполнение к бюджету",
      underspent: "Недоосвоено",
      deficit: "Дефицит",
      surplus: "Профицит",
      balBegin: "Остаток на начало",
      balUsed: "Использовано",
      balEnd: "Остаток на конец",
      sumNote:
        "Показатели за отчетный период; при неполном периоде — нарастающим итогом с начала года.",

      colRes: "Ресурсы",
      colUse: "Использование",
      balResTotal: "Итого ресурсы",
      balUseTotal: "Итого использование",
      balOk: "Баланс сходится",
      balErr: "Обнаружено расхождение",
      residualLbl: "расхождение",
      toleranceLbl: "допуск",
      addedBadge: "+ДОБАВЛЕНО",

      thGroup: "Функциональная группа",
      thExec: "Исп., %",
      thSection: "Раздел",
      thApproved: "Утверждено",
      thUpdated: "Уточнено",
      thAdjusted: "Скоррект.",
      thName: "Наименование",
      thPeriod: "Период",

      finNote:
        "Разделы III–VII отчета: чистое бюджетное кредитование, сальдо по финактивам, дефицит/профицит и его финансирование.",
      dynNote:
        "Динамика доходов, расходов и дефицита по выбранному диапазону лет.",
      noData: "Нет данных за выбранный период",
      onDate: "на",
      fullYear: "полный финансовый год",
      partialLong: "неполный период (с начала года)",
      partialShort: "неполный",
      rangeLbl: "диапазон:",

      // управление
      cBudget: "Бюджет",
      cType: "Тип периода",
      cReport: "Отчетный период",
      cRange: "Динамика",
      tYear: "Год",
      tQuarter: "Квартал",
      bCons: "Сводное представление (район и его МСУ)",
      b8: "8 — Бюджет района (район и его МСУ)",
      b3: "3 — Районный бюджет",
      b7: "7 — Бюджет МСУ",
      cExport: "Выгрузка",
      expXlsx: "Excel",
      expPdf: "PDF",

      // плашки режима
      quarterWarn:
        "<b>Квартальные выгрузки в систему пока не загружаются.</b> Данные доступны по годовым периодам. Переключатель сохранён: контракт API рассчитан на кварталы, они появятся сразу после первой квартальной выгрузки.",
      partialWarn:
        "Выбран неполный период (данные на {{d}}, с начала года). Затраты идут впереди поступлений, поэтому по абсолютным суммам виден дефицит. Это нормальный ход исполнения, а не перерасход: разрыв покрыт свободным остатком прошлого года — см. блок «Баланс ресурсов и использования».",

      // легенда
      legTitle: "Как читать",
      legInc:
        "Доходы: исполнение плана периода — ≥{{good}}% выполнено, {{warn}}–{{good}}% на грани, <{{warn}}% отставание",
      legExp:
        "Расходы: освоение плана периода — ≥{{good}}% освоено, {{warn}}–{{good}}% риск, <{{warn}}% низкое",
      legNd: "нет данных в выгрузке (не ноль)",

      // заголовки секций
      sSum: "Сводка исполнения бюджета",
      sBal: "Баланс ресурсов и использования",
      sInc: "Доходы — по категориям поступлений",
      sExp: "Расходы — по функциональным группам",
      sFin: "Финансирование дефицита и остатки бюджетных средств",
      sTree: "Детализация — дерево бюджетной классификации",
      sDyn: "Динамика по периодам",

      // закладки дерева
      tabInc: "Доходы",
      tabExp: "Расходы",
      tabFin: "Финансирование",

      // состояния (каркас)
      loadError: "Не удалось загрузить данные.",
      retry: "Повторить",
      sectionSoon: "Данных за период нет",
      sectionReady: "Секция готова к отрисовке (следующий слой)",
    },
  },
};

export default Ru;
